/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Driverremittance_Confirm_Success1Inputs */

const vi_driverremittance_confirm_success1 = /** @type {(inputs: Driverremittance_Confirm_Success1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã xác nhận phiếu nộp quỹ.`)
};

/**

* @param {Driverremittance_Confirm_Success1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const driverremittance_confirm_success1 = /** @type {((inputs?: Driverremittance_Confirm_Success1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Driverremittance_Confirm_Success1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_driverremittance_confirm_success1(inputs)
});
export { driverremittance_confirm_success1 as "driverRemittance_confirm_success" }